import { render, staticRenderFns } from "./special_details.vue?vue&type=template&id=61cdeb60&"
import script from "./special_details.vue?vue&type=script&lang=js&"
export * from "./special_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports